import React, { FC, PropsWithChildren } from 'react';

import { useDesktop, useMobile, Button2, Button2Props } from 'Modules/ui3';


export const AccentButton: FC<PropsWithChildren<Button2Props>> = ({ children, sx, ...props }) => {
    const isMobile = useMobile();
    const isDesktop = useDesktop();
    return (
        <Button2
            variantType='brand'
            fullWidth={isMobile}
            size={isDesktop ? 'large' : 'medium'}
            sx={[
                ({ typography }) => ({
                    ...isDesktop && typography.mediumBody1,
                }),
                ...Array.isArray(sx) ? sx : [sx],
            ]}
            {...props}
        >
            {children}
        </Button2>
    );
};
